class MitMapSelectionService {

    constructor(selectChangedCallback, highlightChangedCallback) {
        this.currentlySelected = null;
        this.selectChangedCallback = selectChangedCallback || function(){};
        this.highlightChangedCallback = highlightChangedCallback || function(){};

        this.colorFillHighlight = "#FDFFC1";
        this.colorBorderHighlight = "#FBFF88";
        this.borderHoverSize = "2px";

        this.colorFillSelected = "#FAFDA9";//FDFFCE
        this.colorBorderSelected = "#000000";//FBFF88
        this.borderSelectedSize = "2px";

        //optional predicate; items it matches are styled by the map's selection overlay, not here
        this.skipUIFor = null;
    }

    isUISkipped(space){
        return !!(space && this.skipUIFor && this.skipUIFor(space));
    }

    storeOriginalState(space, d3Element){
        space.uiOriginalState = {
            fill: d3Element.attr("fill"),
            stroke:d3Element.attr("stroke"),
            strokeWidth:d3Element.attr("stroke-width")
        };
    }

    highlight(space, d3Element){
        if(this.currentlySelected && this.currentlySelected.space === space){
            return;
        }

        if(this.isUISkipped(space)){
            this.highlightChangedCallback(space.properties, d3Element);
            return;
        }

        //store the state of the original if no one has yet
        if(typeof space.uiHovered === 'undefined' && typeof space.uiSelected === 'undefined'){
            this.storeOriginalState(space, d3Element)
        }

        this.hoverApplyUI(space, d3Element);

        space.uiHovered = true;

        this.highlightChangedCallback(space.properties, d3Element);
    }

    hoverApplyUI(space, d3Element){
        //Set the values
        if(space.properties.spaceType === 'object' || space.properties.spaceType === 'door'){
            d3Element.attr('stroke', this.colorBorderHighlight)
                     .attr('stroke-width', this.borderHoverSize);
            this.highlightChangedCallback(space.properties, d3Element);
        }
        else{
            d3Element.attr('fill', this.colorFillHighlight);
        }
    }

    unhighlight(space, d3Element){
        if(this.isUISkipped(space)){
            this.highlightChangedCallback(null, null);
            return;
        }

        if(space.uiHovered){
            //reverse all the ui changes
            d3Element.attr('fill', space.uiOriginalState.fill)
                     .attr('stroke', space.uiOriginalState.stroke)
                     .attr('stroke-width', space.uiOriginalState.strokeWidth);

            delete space.uiHovered;
        }

        if(this.currentlySelected && this.currentlySelected.space === space){
            this.selectApplyUI(space, d3Element);//reapply the selected UI since that is now the state
        }

        this.highlightChangedCallback(null, null);
    }


    select(space, d3Element){
        //if already selected, toggle it
        if(this.currentlySelected && this.currentlySelected.space === space){
            this.unselect(space, d3Element);
            return;
        }
        //if another space is selected unselect it first
        if(this.currentlySelected){
            this.unselect(this.currentlySelected.space, this.currentlySelected.d3Element);
        }

        if(space && !this.isUISkipped(space)){
            //store the state of the original if no one has yet
            if(typeof space.uiHovered === 'undefined' && typeof space.uiSelected === 'undefined'){
                this.storeOriginalState(space, d3Element)
            }

            this.selectApplyUI(space, d3Element);

            space.uiSelected = true;
        }

        this.currentlySelected = {
            space:space,
            d3Element:d3Element
        };

        this.selectChangedCallback(space, d3Element);
    }
    selectApplyUI(space, d3Element){
        if(this.isUISkipped(space)) return;

        if(space.properties.spaceType === 'object' || space.properties.spaceType === 'door'){
            d3Element.attr('stroke', this.colorBorderHighlight)
                     .style("stroke-width", this.borderSelectedSize);
        }
        else{
            d3Element.attr('fill', this.colorFillSelected)
                     .attr('stroke', this.colorBorderSelected)
                     .style("stroke-width", this.borderSelectedSize);
        }
    }

    selectEvent(space, d3Element){
        this.selectChangedCallback(space, d3Element);
    }

    unselect(space, d3Element){
        this.currentlySelected = null;
        
        if(space && !this.isUISkipped(space) && space.uiOriginalState){
            d3Element.attr('fill', space.uiOriginalState.fill)
                     .attr('stroke', space.uiOriginalState.stroke)
                     .style("stroke-width", space.uiOriginalState.strokeWidth);

            delete space.uiSelected;
        }

        this.selectChangedCallback(null, null);
    }

}

export default MitMapSelectionService;
